export default __webpack_public_path__ + "static/media/20.13834da5.png";